<h3>DE CIFRIS MEDIOLANENSIBUS</h3>
<p>Il ciclo di seminari De Cifris Mediolanensibus presenta risultati
	di ricerca nell'ambito della crittografia e applicazioni. I seminari saranno
	tenuti da esperti nazionali e internazionali, in lingua inglese e italiana,
	e saranno aperti a tutti. </p>
<h5>Comitato organizzatore</h5>
<ul>
	<li> Francesca Dalla Volta, Università di Milano Bicocca;</li>
	<li> Alberto Leporati, Università di Milano Bicocca;</li>
	<li> Giacomo Verticale, Politecnico di Milano;</li>
	<li> Enrico Zimuel, Elastic;</li>
	<li> Andrea Visconti, Università di Milano.</li>
</ul>


<h4>SEMINARI RECENTI</h4>
<div>
	<li>
		<b> 24 Maggio 2022 - 15:30</b>
		<ul>
			<li>
				<b>Michela Ceria</b> -- Politecnico di Bari <br>
				<i>"A Blockchain Hour: Monero's World"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifris
							Mediolanensibus/Allegato 3_Ceria_Mediolanesibus.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
							Mediolanensibus/Ceria_24_maggio.pdf">Slide</a>
			</li>
		</ul>
	</li>
</div>
<h4>PROSSIMI SEMINARI</h4>
<p class="warning">Avviso: causa dell'emergenza Coronavirus (Covid-19) organizzeremo i prossimi eventi in webinar.</p>
<ul>

</ul>
<h4>SEMINARI PASSATI</h4>
<div>
	<ul>
		<li>
			<b>12 Ottobre 2021</b> -- 15:00
			<ul>
				<li>
					<b>Enrico Zimuel</b> -- Principal Software Engineer, Elastic <br>
					<i>"Introduzione alle problematiche nell'implementazione dei sistemi crittografici"</i><br>
					<a
						href="../../../assets/attivita/seminariLocali/deCifrisMediolanensibus/EnricoZimuel.pdf">Locandina</a>
					--
					<a
						href="../../../assets/attivita/seminariLocali/deCifrisMediolanensibus/Zimuel12102021.pdf">Slide</a>
					<br>
				</li>
			</ul>
		</li>
		<li>
			<b>9 Dicembre 2020</b>
			<ul>
				<li>
					<b>Lorenzo Grassi</b> -- University of Technology of Graz: <br>
					<i>Symmetric-Key Encryption Schemes for MPC Applications</i>.<br>
					<a href="../../../../assets/attivita/seminariLocali/deCifrisMediolanensibus/09.12.2020-Grassi.pdf">
						Locandina</a> --
					<a href="../../../../assets/attivita/seminariLocali/deCifrisMediolanensibus/slide_Grassi.pdf">
						Slide</a> --
					<a href="https://youtu.be/fH82NrsJgE4">Video</a>.
					<br>
				</li>
			</ul>
		</li>
	</ul>
</div>